<div class="frame-in">
  <div class="items africa-2-frame">

    <svg class="road africa-2-1">
      <style type="text/css">
        tspan {
        white-space: pre
      }

      .shp1 {
      fill: none;
      stroke: #ffffff;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-width: 5;
      stroke-dasharray: 15,15
    }
  </style>
  <g id="GAME UI">
    <g id="ZONE 3">
      <g id="ZONE 3">
        <g id="ZONE 1">
          <g id="Track lines ZONE1">
            <path id="Shape 2233" class="shp1" d="M222.17 89.76C222.17 89.76 317.02 94.54 336.07 44.12C352.4 0.9 403.96 0.92 427.9 0.85" />
            <path id="Shape 1601" class="shp1" d="M181.97 88.55C181.97 88.55 155.23 88.3 120.16 92.96C85.08 97.62 85.21 160.91 113.33 173.34C139 184.69 187.45 180.29 261.01 176.58C334.57 172.87 392.36 206.72 389.05 267.53C385.74 328.35 285.34 356.05 285.34 356.05C285.34 356.05 206.83 379.11 188.16 331.75" />
            <path id="Shape 3937" class="shp1" d="M-13.62 135.08C-13.62 135.08 47.31 135.64 49.08 173.93C50.85 212.22 16.82 310.06 81.75 313.45C146.69 316.84 174.55 316.2 174.55 316.2" />
            <path id="Shape 1585" class="shp1" d="M-5.24 -3.54C-21.56 -2.65 -119.63 9.95 -115.06 79.07C-112.49 118.01 -73.53 115.73 -31.48 120.86" />
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>

<svg class="road africa-2">
  <style type="text/css">
    tspan {
    white-space: pre
  }

  .shp0 {
  fill: none;
  stroke: #ffffff;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 5;
  stroke-dasharray: 15,15
}
</style>
<g id="GAME UI">
  <g id="ZONE 3">
    <g id="ZONE 3">
      <g id="Track lines ZONE1">
        <path id="Shape 728 copy" class="shp0" d="M506 440C506 440 570.48 460.92 555 510" />
        <path id="Shape 728" class="shp0" d="M311 442C311 442 331.29 459.56 357 455C382.71 450.44 400.74 435 464 435" />
        <path id="Shape 727" class="shp0" d="M363 355C363 355 355.37 392.58 318 406" />
        <path id="Shape 1601" class="shp0" d="M149.63 209.75C149.63 209.75 180.92 209.8 183 224C185.08 238.2 200.02 248.58 247 248C293.98 247.42 363.54 271.96 363 317" />
        <path id="Shape 3937" class="shp0" d="M118 59C118 59 71.74 76.92 43 74C-5.92 69.03 -6.39 168.63 9 183C30.55 203.13 60.71 203.72 89 203" />
        <path id="Shape 1585" class="shp0" d="M21 0C21 0 17.26 26.66 55 17C55 17 101.85 3.05 106 25" />
      </g>
    </g>
  </g>
</g>
</svg>
<div class="country africa-2"></div>
<div class="poi quiz quiz-1" (click)="goQuiz()" [ngClass]="{'lock': quizLevel < 9, 'active': quizLevel === 9 && tick2Quiz}"></div>

@for (zone of zones; track zone) {
  <div>
    <div class="country {{zone.class}}" [ngClass]="{'hover': zone.hover}"></div>
  </div>
}
@for (zone of zones; track zone; let i = $index) {
  <div
    class="poi {{zone.class}}"
    [ngClass]="{active: zone.active, 'lock': zone.locked}"
    (mouseenter)="mouseEnter(zone)"
    (mouseleave)="mouseLeave(zone)"
    (click)="selectZone(zone)">
    <span>{{ zone.locked ? '' : zone.number}}</span>
  </div>
}

<div class="poi africa-1-3" style="cursor: default !important; filter: saturate(30%);"><span>31</span></div>
<div class="poi africa-1-4" style="cursor: default !important; filter: saturate(30%);"><span>32</span></div>
</div>
</div>

<img class="frame-title" src="assets/images/zones/africa-2/title.png">

<audio id="introductionAudio" (ended)="playBgAudio()">
  <source src="assets/sounds/country.wav" type="audio/wav">
</audio>
<audio id="bgAudio" (ended)="playIntroductionAudio()">
  <source src="assets/sounds/zone-b-g-sound.mp3" type="audio/mpeg">
</audio>

<div class="footer">
  <ul class="zone-menu">
    <li>
      @if (!haveAccess('3-1')) {
        <span class="lock"></span>
      }
      @if (haveAccess('3-1')) {
        <a class="menu-item" [routerLink]="[ '/game/africa-1' ]" routerLinkActive="active">1</a>
      }
    </li>
    <li>
      @if (!haveAccess('3-2')) {
        <span class="lock"></span>
      }
      @if (haveAccess('3-2')) {
        <a class="menu-item" [routerLink]="[ '/game/africa-2' ]" routerLinkActive="active">2</a>
      }
    </li>
    <li>
      @if (!haveAccess('3-3')) {
        <span class="lock"></span>
      }
      @if (haveAccess('3-3')) {
        <a class="menu-item" [routerLink]="[ '/game/africa-3' ]" routerLinkActive="active">3</a>
      }
    </li>
  </ul>
  <img class="footer-bg" src="assets/images/zones/africa-2/footer.png">
</div>

<audio id="continentHover">
  <source src="assets/sounds/continent_hover.mp3" type="audio/mpeg">
</audio>
<audio id="continentClick">
  <source src="assets/sounds/continent_selection.mp3" type="audio/mpeg">
</audio>
